import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  height: 35px;
  width: 35px;
`
export const ProfileIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17.4999" cy="17.062" r="16.1875" />
      <path d="M17.3167 18.0571C22.4354 18.0571 26.8775 20.9562 29.0913 25.2C30.7304 22.8637 31.6958 20.0171 31.6958 16.9458C31.6958 9.00373 25.2588 2.56665 17.3167 2.56665C9.37458 2.56665 2.9375 9.00373 2.9375 16.9458C2.9375 20.0171 3.9 22.8637 5.54208 25.2C7.75292 20.9533 12.195 18.0571 17.3167 18.0571Z" />
      <path
        d="M17.3166 31.325C22.1874 31.325 26.4924 28.9042 29.0911 25.2C26.8774 20.9563 22.4353 18.0571 17.3166 18.0571C12.1978 18.0571 7.75281 20.9534 5.53906 25.2C8.14073 28.9042 12.4457 31.325 17.3166 31.325Z"
        fill="white"
      />
      <path
        d="M17.3166 16.6663C20.1967 16.6663 22.5316 14.3315 22.5316 11.4513C22.5316 8.57116 20.1967 6.23633 17.3166 6.23633C14.4364 6.23633 12.1016 8.57116 12.1016 11.4513C12.1016 14.3315 14.4364 16.6663 17.3166 16.6663Z"
        fill="white"
      />
    </Svg>
  )
}
